import { SectionComponentClass } from '@sections/SectionComponent'
import { Store } from '@stores/Store'
import { simulatorPageSection } from '@utils/sections/Section.util'

// Dormant extension point. One live calculation version today, but the registry
// (countries-versions.json + validFrom/validUntil) stays in place because Amway
// has requested dual-version display before and may again. A future version adds
// its gates here without touching pages or calculations.
export class VersionHelper {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Pages

  get simulatorPageSection(): SectionComponentClass[] {
    return simulatorPageSection()
  }


  // Calculations
  // Summary Total Income

  get totalIncomeMonthlyAmount() {
    return this.store.summaryCalculation.totalIncomeMonthlyAmount
  }

  get totalIncomeAnnualAmount() {
    return this.store.summaryCalculation.totalIncomeAnnualAmount
  }

}
